import React,{useCallback} from 'react';
import {useNavigate} from 'react-router-dom';

import Form from './Form';

import {Modal, Button} from 'react-bootstrap';

import {ReactComponent as ImgAccount} from '../../../../src/asset/img/icon/account.svg';
import * as IconFi from 'react-icons/fi';

import './Login.scss';

const ModalLogin = props => {
    const navigate = useNavigate()

    // --------------------------------------------------------------------------------------------------- show and hide

    const handlePopstate = useCallback(() => {

        // اگر popstate بود مودال بسته نشود و back هم غیرفعال می شود، این مودال فقط با دکمه close بسته می شود
        navigate(1)

    }, [])

    const onShowHandler = () => {

        document.getElementById('modalLogin').style.paddingRight = document.querySelector('body').style.paddingRight

        navigate('#modalLogin')
        window.addEventListener('popstate',  handlePopstate);

    }

    const onHideHandler = () => {

        navigate(-1)

        if (document.querySelectorAll('.modal').length < 2) {
            window.removeEventListener('popstate', handlePopstate)
        }

        props.onHide()

    }

    // -----------------------------------------------------------------------------------------------------------------

    return (
        // مودال می بایست با کیبورد و back مرورگر بسته نشود، overflow-hidden اسکرول بار نمایش داده شده با دکمه scape را مخفی می کند
        <Modal id="modalLogin" aria-labelledby="modalLoginTitle" {...props} backdrop="static" fullscreen onShow={onShowHandler} keyboard={false} className="ltr bg-body overflow-hidden" dialogClassName="rtl" contentClassName="container-lg px-0">
            <Modal.Header className="position-sticky top-0 bg-body">
                <Button variant="link" onClick={onHideHandler} className="my-md-1 text-body border-0 btn-icon"><IconFi.FiArrowRight size={24} className="sw-1 m-2"/></Button>
            </Modal.Header>
            <Modal.Body className="overflow-visible d-flex flex-column">
                <div className="d-flex flex-column justify-content-center align-items-center flex-grow-1">
                    <ImgAccount width={96} height={96} className="sw-1 mb-3 text-white text-opacity-60 flex-shrink-0"/>
                    <h4 className="mb-5 fw-bold fs-2">ورود کاربران</h4>
                    <div className="position-relative">
                        <Form onHide={onHideHandler}/>
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    )
}

export default ModalLogin;